import { z } from 'zod';
export const companyEnrichmentPersonResponseSchema = z.object({
    id: z.string().uuid(),
    firstName: z.string(),
    lastName: z.string(),
    fullName: z.string(),
    title: z.string().nullable(),
    seniority: z.string().nullable(),
    department: z.string().nullable(),
    email: z.string().nullable(),
    emailVerified: z.boolean(),
    linkedinUrl: z.string().nullable(),
    /** Set once "Add as contact" has been used for this person — the UI
     * shows that state instead of offering the action again. */
    contactId: z.string().uuid().nullable(),
});
export const companyEnrichmentTechSchema = z.object({ category: z.string(), name: z.string() });
export const companyEnrichmentResponseSchema = z.object({
    companyId: z.string().uuid(),
    provider: z.string(),
    logoUrl: z.string().nullable(),
    description: z.string().nullable(),
    foundedYear: z.number().int().nullable(),
    employeeCount: z.number().int().nullable(),
    employeeRange: z.string().nullable(),
    linkedinUrl: z.string().nullable(),
    twitterUrl: z.string().nullable(),
    facebookUrl: z.string().nullable(),
    instagramUrl: z.string().nullable(),
    websiteTitle: z.string().nullable(),
    websiteDescription: z.string().nullable(),
    technologies: z.array(companyEnrichmentTechSchema),
    people: z.array(companyEnrichmentPersonResponseSchema),
    lastEnrichedAt: z.string().datetime().nullable(),
    lastEnrichError: z.string().nullable(),
});
//# sourceMappingURL=schemas.js.map